/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListOrderBooksOptions, ListOrderBooksResponses } from '../types/ListOrderBooks'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary List order books
 * {@link /v1/orderbooks}
 */
export function listOrderBooks<ThrowOnError extends boolean = true>(
  options: Options<ListOrderBooksOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListOrderBooksResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/orderbooks',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListOrderBooksResponses, ThrowOnError>>,
  )
}
